import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, RAFUnitOfWork } from 'src/app/core/core.module';
import { Invoice } from 'src/app/core/data/entities';
import { InputDialogComponent } from 'src/app/shared/shared.module';

@Component({
    selector: 'app-invoice-search',
    templateUrl: './invoice-search.component.html',
    styleUrls: ['./invoice-search.component.scss'],
    standalone: false
})
export class InvoiceSearchComponent implements OnInit {
    invoices: any;
    showAll = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(private uow: RAFUnitOfWork, private router: Router, private appInfo: AppInformationService, private modalService: BsModalService) {}

    async ngOnInit() {
        await this.getData(100);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                },
                location: 'after'
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    }
                },
                location: 'after'
            }
        );
    }

    async getData(take?: number | null) {
        this.invoices = (await this.uow.getInvoices(take)) as Invoice[];
    }

    async toggleShowAll() {
        this.appInfo.pleaseWaitShow();
        this.showAll = !this.showAll;
        await this.getData(this.showAll ? null : 500);
        this.appInfo.pleaseWaitHide()
    }

    selectionChange(e) {}

    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (!!e.data.paid) {
                // console.log(e);
                e.rowElement.className = e.rowElement.className + ' paid-grid';
            }
        }
    }
    async rowDoubleClick(e) {
        if (!e.data) return;
        await this.open(e.data.id);
    }
    async open(id?: number) {
        this.router.navigate(['/invoices/' + (!!id ? id : 'new')]);
    }

    async markAsPaid() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;
        const result = await (confirm('Are you sure you want to mark this invoice as Paid?', `${this.appInfo.settings.company}`) as Promise<boolean>);
        if (!!result) {
            this.appInfo.pleaseWaitShow();
            selectedRow.paid = new Date();
            await this.uow.commit();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
    }
    async mailed() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                mode: 'date',
                dialogHeader: 'Set Mailed Date',
                dialogPrompt: 'Mailed',
                dialogValue: selectedRow.mailed ? selectedRow.mailed : new Date()
            }
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                selectedRow.mailed = result.value;
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }
    async delete() {
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (selectedRow.length === 0) return;
        const result = await (confirm('Are you sure you want to DELETE this invoice?', `${this.appInfo.settings.company}`) as Promise<boolean>);
        if (!!result) {
            if (!!selectedRow.paid) {
                await alert('This invoice is marked as Paid.  It cannot be deleted.', `${this.appInfo.settings.company}`);
                return;
            }
            this.appInfo.pleaseWaitShow();
            selectedRow.deleted = new Date();
            await this.uow.commit();
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
    }
}
